



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class ModalWrapper extends Vue {

  @Prop() public label!: string;
  @Prop() public icon!: string;
  @Prop() public type!: string;
  @Prop() public expanded!: boolean;
  @Prop() public isRight!: boolean;
  private isModalActive: boolean = false;

  get buttonType() {
    return this.type || 'is-primary';
  }

}
